const defaults = {
    initialized: false,
    currentPosition: 0,
    scrolling: false,
    lecture: {},
    channelLectures: [],
    channel: {},
    liveroom: {},
    showToolbar: true,
    showDiscussArea: true,
    showDiscussListArea: true,
    showTopVideo: true,
    showOptions: false,
    isActiveHideTopVideo: false,
    showDiscussPanel: false,
    showTextareaPanel: false,
    showFilePanel: false,
    role: {},
    options: {},
    stats: {},
    error: null,
    showMaterialPanel: false,
    showCardPanel: false,
    showRedpackPanel: false,
    topNotify: {
        show: false,
        text: '正在输入...'
    },
    reply: null,
    reward: {
        show: false
    },
    showScrollButton: false,
    showCheckIn: false,
    showCloseUpDialog: false,
    showNoListenDialog: false,
    showedNoListenDialog: false,
    showShareCardMsgDialog: false,
    shareCardImg: '',
    isShowMedalModal: false,
    medalType: '',
    // 课程未结束弹窗
    isThisClassHasAudio: false,
    isThisClassFakeClose: false,
    isShowMenuPopup: false,
    EvaluationAudioCount: 0,
    EvaluationAudioLast: false,
    noTipsType: 'listen',
    showQuickGuide: false,
};


export default (state = defaults, action) => {
    switch (action.type) {
        case 'CLASSROOM_INIT':
            return {...state, initialized: true, ...action.payload}
        case 'CLASSROOM_SHOW_MENU':
            return {
                ...state,
                showMenu: true,
                menus: action.payload.menus,
                operatingMessage: action.payload.operatingMessage
            }
        case 'CLASSROOM_HIDE_MENU':
            return {...state, showMenu: false}
        case 'CLASSROOM_HIDE_TOOLBAR':
            return {...state, showToolbar: false}
        case 'CLASSROOM_SET_OPTION':
            const newOptions = {...state.options, ...action.payload}
            return {...state, options: newOptions}
        case 'CLASSROOM_SET_ERROR':
            return {...state, initialized: true, error: action.payload}
        case 'CLASSROOM_STOP_SCROLLING':
            return {...state, scrolling: false}
        case 'CLASSROOM_SET_CURRENT_POSITION':
            return {...state, currentPosition: action.payload.currentPosition, scrolling: action.payload.scrolling}
        case 'CLASSROOM_TOUCH_START':
            return {...state, scrolling: false, showToolbar: true}
        case 'CLASSROOM_SHOW_TOP_VIDEO':
            return {...state, showTopVideo: true, isActiveHideTopVideo: false}
        case 'CLASSROOM_HIDE_TOP_VIDEO':
            return {...state, showTopVideo: false, isActiveHideTopVideo: true}
        case 'CLASSROOM_HIDE_OPTIONS':
            return {...state, showOptions: false}
        case 'CLASSROOM_SHOW_OPTIONS':
            return {...state, showOptions: true}
        case 'CLASSROOM_VIRTUAL_FOCUS':
            return window.systemType === 'android' ? {...state, showTopVideo: false} : state
        case 'CLASSROOM_VIRTUAL_BLUR':
            return window.systemType === 'android' && !state.isActiveHideTopVideo ? {...state, showTopVideo: true} : state
        case 'CLASSROOM_HIDE_DISCUSS_PANEL':
            let originHideState = {...state, showDiscussPanel: false};
            return window.systemType === 'android' && !state.isActiveHideTopVideo ? Object.assign(originHideState, {showTopVideo: true}) : originHideState;
        case 'CLASSROOM_SHOW_DISCUSS_PANEL':
            let originShowState = {...state, showDiscussPanel: action.payload};
            return window.systemType === 'android' ? Object.assign(originShowState, {showTopVideo: false}) : originShowState;
        case 'CLASSROOM_HIDE_TEXTAREA_PANEL':
            return {...state, showTextareaPanel: false}
        case 'CLASSROOM_SHOW_TEXTAREA_PANEL':
            return {...state, showTextareaPanel: true}
        case 'CLASSROOM_SHOW_FILE_PANEL':
            return {...state, showFilePanel: true}
        case 'CLASSROOM_HIDE_FILE_PANEL':
            return {...state, showFilePanel: false}
        case 'CLASSROOM_HIDE_SCROLL_BUTTON':
            return {...state, showScrollButton: false}
        case 'CLASSROOM_SHOW_SCROLL_BUTTON':
            return {...state, showScrollButton: true}
        case 'CLASSROOM_HIDE_REWARD':
            return {
                ...state, reward: {
                    show: false
                }
            }
        case 'CLASSROOM_SHOW_REWARD':
            return {
                ...state, reward: {
                    show: true,
                    account: action.payload.account
                }
            }
        case 'OPEN_MATERIAL_PANEL':
            return {...state, showMaterialPanel: true}
        case 'HIDE_MATERIAL_PANEL':
            return {...state, showMaterialPanel: false}
        case 'OPEN_CARD_PANEL':
            return {...state, showCardPanel: true}
        case 'HIDE_CARD_PANEL':
            return {...state, showCardPanel: false}
        case 'OPEN_REDPACK_PANEL':
            return {...state, showRedpackPanel: true}
        case 'HIDE_REDPACK_PANEL':
            return {...state, showRedpackPanel: false}
        case 'CLASSROOM_SHOW_TOPNOTIFY':
            return {
                ...state, topNotify: {
                    show: true,
                    text: action.payload
                }
            }
        case 'CLASSROOM_HIDE_TOPNOTIFY':
            return {
                ...state, topNotify: {
                    show: false,
                    text: ''
                }
            }
        case 'CLASSROOM_SET_REPLY':
            return {...state, reply: action.payload}
        case 'FOLLOW_LIVEROOM':
            if (action.payload.liveroom_id === state.liveroom.id) {
                const newRole = {...state.role, is_fans: true}
                return {...state, role: newRole}
            }
            return state
        case 'POPUP_RECEIVE':
            if (action.payload.type === 'discuss_text') {
                const newStats = {...state.stats, discuss_count: state.stats.discuss_count + 1}
                return {...state, stats: newStats}
            }
            return state
        case 'PAGE_INIT':
            return defaults
        case 'CLASSROOM_SHOW_CHECK_IN':
            return {...state, showCheckIn: true}
        case 'CLASSROOM_HIDE_CHECK_IN':
            return {...state, showCheckIn: false}
        case 'CLASSROOM_UPDATE_POPULAR':
            const newStats = {...state.stats, popular: action.payload};
            return {...state, stats: newStats};
        case 'CLASSROOM_SHOW_CLOSEUP_DIALOG':
            return {...state, showCloseUpDialog: true};
        case 'CLASSROOM_HIDE_CLOSEUP_DIALOG':
            return {...state, showCloseUpDialog: false};
        case 'CLASSROOM_SHOW_NOLISTEN_DIALOG':
            return {...state, showNoListenDialog: true, noTipsType: action.payload};
        case 'CLASSROOM_HIDE_NOLISTEN_DIALOG':
            return {...state, showNoListenDialog: false};
        case 'CLASSROOM_SHOW_SHOWED_NOLISTEN_DIALOG':
            return {...state, showedNoListenDialog: true};
        case 'CLASSROOM_HIDE_SHOWED_NOLISTEN_DIALOG':
            return {...state, showedNoListenDialog: false};
        case 'CLASSROOM_SHOW_DISCUSS_LIST_AREA':
            return {...state, showDiscussListArea: true};
        case 'CLASSROOM_HIDE_DISCUSS_LIST_AREA':
            return {...state, showDiscussListArea: false};
        case 'CLASSROOM_SHOW_SHARE_CARD_MSG_DIALOG':
            return {...state, showShareCardMsgDialog: true, shareCardImg: action.payload};
        case 'CLASSROOM_HIDE_SHARE_CARD_MSG_DIALOG':
            return {...state, showShareCardMsgDialog: false};
        case 'CLASSROOM_SET_IS_SHOW_MEDAL_MODAL':
            return {...state, isShowMedalModal: action.payload};
        case 'CLASSROOM_SET_MEDAL_TYPE':
            return {...state, medalType: action.payload};
        case 'CLASSROOM_HAS_AUDIO_FOR_DIALOG':
            return {...state, isThisClassHasAudio: true};
        case 'CLASSROOM_FAKE_CLOSE_FOR_DIALOG':
            return {...state, isThisClassFakeClose: true};
        case 'CLASSROOM_SET_CHANNEL_LECTURES':
            return {...state, channelLectures: action.payload};
        case 'CLASSROOM_SET_MENU_DISPLAY':
            return {...state, isShowMenuPopup: action.payload};
        case 'CLASSROOM_SET_AUDIO_LISTENCOUNT':
            return {...state, EvaluationAudioCount: state.EvaluationAudioCount + 1}
        case 'CLASSROOM_SET_IS_AUDIO_LAST':
            return {...state, EvaluationAudioLast: true}
        case 'CLASSROOM_SHOW_QUICK_GUIDE':
            return {...state, showQuickGuide: true}    
        case 'CLASSROOM_HIDE_QUICK_GUIDE':
            return {...state, showQuickGuide: false}    
        default:
            return state
    }
}





// WEBPACK FOOTER //
// ./src/reducers/classroom.js